module.exports = __webpack_public_path__ + "static/media/lock@2x.93938890.jpg";